import { useSyncExternalStore } from 'react';
export type DraftIssue = { id:string; subject:string; body:string; files:File[]; category:'MAINTENANCE'|'DIAGNOSIS'|'PREPARATION'|'OTHER' };
// Temporary, per-vehicle worksheet. Never sent until the customer signs; no customer data on disk.
const drafts = new Map<string, DraftIssue[]>();
const listeners = new Set<()=>void>();
const empty:DraftIssue[]=[];
export function useServiceDraft(key:string) {
 const items=useSyncExternalStore(callback=>{listeners.add(callback);return()=>{listeners.delete(callback);};},()=>drafts.get(key)||empty);
 const update=(next:DraftIssue[])=>{drafts.set(key,next);listeners.forEach(fn=>fn());};
 return {items,update};
}
export function draftBody(items:DraftIssue[]){return items.map((item,i)=>`PROBLEMA ${i+1} — ${item.subject}\n${item.body}`).join('\n\n');}
